/**
 * Polski katalog kopii do funkcji `auth` (logowanie, rejestracja, weryfikacja
 * linka magicznego, resetowanie/ustawianie hasła). Klucze mapują 1:1 do
 * wywołań `t('auth.*')` w `packages/@gamecodex/world-ui/src/features/auth/*`.
 * Wartości są dokładnymi oryginalnymi polskimi stringami.
 */
export const authPl = {
  // ── AuthShell ────────────────────────────────────────────────────────────
  'auth.shell.homeAriaLabel': 'Strona główna Grymwyrd',
  'auth.shell.logoAlt': 'Grymwyrd',

  // ── OAuthButtons ─────────────────────────────────────────────────────────
  'auth.oauth.continueWithGoogle': 'Kontynuuj z Google',
  'auth.oauth.continueWithDiscord': 'Kontynuuj z Discord',

  // ── AccountVerifyPage ────────────────────────────────────────────────────
  'auth.verify.seoTitle': 'Logowanie',
  'auth.verify.seoDescription': 'Weryfikacja Twojego linka do logowania w Grymwyrd.',
  'auth.verify.errorMissingToken':
    'Linku do logowania brakuje tokenu. Poproś o nowy link na stronie logowania.',
  'auth.verify.errorInvalidOrExpired':
    'Linku do logowania jest nieprawidłowy lub wygasł. Poproś o nowy link na stronie logowania.',
  'auth.verify.confirming': 'Potwierdzanie Twojego logowania…',
  'auth.verify.signedInHeading': 'Jesteś zalogowany',
  'auth.verify.signedInAsPrefix': 'Zalogowany jako',
  'auth.verify.signedInAsSuffix': '. Przenoszę Cię do Twojego sanctum…',
  'auth.verify.takingYouToSanctum': 'Przenoszę Cię do Twojego sanctum…',
  'auth.verify.goNow': 'Idź teraz',
  'auth.verify.problemHeading': 'Problem z linkiem do logowania',
  'auth.verify.backToSignIn': 'Powrót do logowania',

  // ── LoginPage ────────────────────────────────────────────────────────────
  'auth.login.errorEnterEmailFirst': 'Wpisz swój email powyżej, a następnie poproś o link.',
  'auth.login.seoTitle': 'Przekrocz Próg',
  'auth.login.seoDescription': 'Zaloguj się do Grymwyrd i powróć do swojej legendy w wiecznym zmroku.',
  'auth.login.eyebrow': 'Powróć, Wędrowcze',
  'auth.login.title': 'Przekrocz Próg',
  'auth.login.blurb': 'Wymów swoją nazwę i tajne słowo, aby powrócić do wiecznego zmroku.',
  'auth.login.noPactYet': 'Jeszcze bez przymierza?',
  'auth.login.forgeYourLegend': 'Ukowaj swoją legendę',
  'auth.login.emailLabel': 'Email',
  'auth.login.emailPlaceholder': 'ty@grymwyrd.com',
  'auth.login.passwordLabel': 'Hasło',
  'auth.login.forgotPassword': 'Zapomniane hasło?',
  'auth.login.submitBusy': 'Przekraczam…',
  'auth.login.submit': 'Wstąp',
  'auth.login.dividerOr': 'lub',
  'auth.login.magicSentPrefix': 'Link do logowania jest w drodze',
  'auth.login.magicSentTo': 'do',
  'auth.login.magicSentSuffix': '. Sprawdź swoją skrzynkę.',
  'auth.login.emailMeSignInLink': 'Wyślij mi link do logowania na email',
  'auth.login.mockAuthPrefix': 'Dev mock auth: każdy email działa. Użyj',
  'auth.login.mockAuthOr': 'lub',
  'auth.login.mockAuthSuffix': 'dla podwyższonych uprawnień.',

  // ── RegisterPage ─────────────────────────────────────────────────────────
  'auth.register.errorDisplayNameRequired': 'Wybierz nazwę, pod którą będzie opowiadana Twoja legenda.',
  'auth.register.errorEmailRequired': 'Email jest potrzebny do zapieczętowania przymierza.',
  'auth.register.errorEmailInvalid': 'Ten email wygląda nieprawidłowo.',
  'auth.register.errorPasswordTooShort': 'Twoje tajne słowo musi mieć co najmniej 8 znaków.',
  'auth.register.errorMustBeAdult': 'Musisz mieć co najmniej 13 lat, aby dołączyć do Grymwyrd.',
  'auth.register.errorMustAcceptTerms': 'Musisz zaakceptować przymierze (warunki), aby kontynuować.',
  'auth.register.errorIncomplete': 'Niektóre znaki na Twoim przymierzu są niekompletne. Patrz poniżej.',
  'auth.register.seoTitle': 'Zacznij Swoją Opowieść',
  'auth.register.seoDescription':
    'Utwórz konto Grymwyrd, wskrześ awatara i niech Twoja historia stanie się kanona.',
  'auth.register.eyebrow': 'Odkryj Wioskę Greywick',
  'auth.register.title': 'Zacznij Swoją Opowieść',
  'auth.register.blurb': 'Budzisz się z eterycznych marzeń i otwierasz oczy…',
  'auth.register.alreadyBound': 'Już związany z zmrokiem?',
  'auth.register.loginToExisting': 'Zaloguj się na Istniejące Konto',
  'auth.register.displayNameLabel': 'Nazwa wyświetlana',
  'auth.register.displayNamePlaceholder': 'Pusty Rycerz',
  'auth.register.displayNameHint': 'Ta nazwa nadaje Twojemu publicznemu awatarowi i wkładom.',
  'auth.register.emailLabel': 'Email',
  'auth.register.emailPlaceholder': 'ty@grymwyrd.com',
  'auth.register.passwordLabel': 'Hasło',
  'auth.register.passwordPlaceholder': 'Co najmniej 8 znaków',
  'auth.register.agreementsLegend': 'Porozumienia',
  'auth.register.adultConfirmPrefix': 'Potwierdzam, że mam',
  'auth.register.adultConfirmEmphasis': '13 lat lub więcej',
  'auth.register.adultConfirmSuffix': '.',
  'auth.register.acceptPrefix': 'Akceptuję',
  'auth.register.termsOfThePact': 'Warunki Przymierza',
  'auth.register.acceptSuffix': '.',
  'auth.register.submitBusy': 'Zapieczętowuję przymierze…',
  'auth.register.submit': 'Pojaw się',
  'auth.register.dividerOr': 'lub',
  'auth.register.mockAuthNote': 'Dev mock auth: rejestracja utrzymuje się lokalnie. Nie jest wysyłana żadna wiadomość email.',
  'auth.register.lastUpdated': 'Ostatnia aktualizacja {date}',

  // ── ResetPasswordPage ────────────────────────────────────────────────────
  'auth.reset.errorInvalidEmail': 'Wpisz email powiązany z Twoim przymierzem.',
  'auth.reset.seoTitle': 'Resetuj Hasło',
  'auth.reset.seoDescription':
    'Zapomniane hasło? Wyślemy Ci jednorazowy link; kliknij go, aby wybrać nowe hasło.',
  'auth.reset.eyebrow': 'Zagubione Słowo',
  'auth.reset.title': 'Resetuj Hasło',
  'auth.reset.blurb':
    'Szepcz swój email, a jednorazowy link zostanie wysłany w ciemność. Podążaj za nim, a ustalisz nowe hasło.',
  'auth.reset.rememberedAfterAll': 'Jednak pamiętasz?',
  'auth.reset.loginToExisting': 'Zaloguj się na Istniejące Konto',
  'auth.reset.successMessage':
    'Jeśli konto istnieje dla {email}, wysłano jednorazowy link. Otwórz go, aby się zalogować i ustawić nowe hasło — sprawdź email i folder spam.',
  'auth.reset.sendToDifferentEmail': 'Wyślij na inny email',
  'auth.reset.emailLabel': 'Email',
  'auth.reset.emailPlaceholder': 'ty@grymwyrd.com',
  'auth.reset.submitBusy': 'Wzywam…',
  'auth.reset.submit': 'Wyślij Link do Logowania',

  // ── SetPasswordPage ──────────────────────────────────────────────────────
  'auth.setPassword.errorTooShort': 'Wybierz hasło o długości co najmniej 8 znaków.',
  'auth.setPassword.errorMismatch': 'Te hasła się nie zgadzają.',
  'auth.setPassword.seoTitle': 'Ustaw Hasło',
  'auth.setPassword.seoDescription': 'Wybierz nowe hasło do swojego konta Grymwyrd.',
  'auth.setPassword.eyebrow': 'Zapieczętuj Przymierze',
  'auth.setPassword.title': 'Ustaw Nowe Hasło',
  'auth.setPassword.blurb':
    'Jesteś zalogowany. Wybierz nowe hasło — będziesz mógł go użyć następnym razem wraz z magicznym linkiem.',
  'auth.setPassword.ratherNot': 'Wolisz nie?',
  'auth.setPassword.skipForNow': 'Pomiń na razie',
  'auth.setPassword.successMessage': 'Twoje hasło jest ustawione. Przenoszę Cię do Twojego sanctum…',
  'auth.setPassword.newPasswordLabel': 'Nowe hasło',
  'auth.setPassword.newPasswordPlaceholder': 'Co najmniej 8 znaków',
  'auth.setPassword.confirmPasswordLabel': 'Potwierdź hasło',
  'auth.setPassword.confirmPasswordPlaceholder': 'Wpisz je ponownie',
  'auth.setPassword.submitBusy': 'Zapieczętowuję…',
  'auth.setPassword.submit': 'Zapisz Hasło',
}
